import { COUNT_BIKE_MODELS_REQUEST, COUNT_BIKE_MODELS_REQUEST_FAILURE, COUNT_BIKE_MODELS_REQUEST_SUCCESS } from '../constants/bike_model.constants';

export const countBikeModelsRequest = (id, model, priority, we_dont_want) => ({
    type: COUNT_BIKE_MODELS_REQUEST, id, model, priority, we_dont_want,
});

export const countBikeModelsRequestSuccess = payload => ({ type: COUNT_BIKE_MODELS_REQUEST_SUCCESS, payload });
export const countBikeModelsRequestFailure = error => ({ type: COUNT_BIKE_MODELS_REQUEST_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/redux/actions/count_bike_models.actions.js